<template>
  <div>
    <el-card v-auth="'/agentUserInfo/pageList'">
      <el-row :gutter="20">
        <el-col :sm="12" :md="4" :lg="4">
          <el-select v-model="searchForm.agentLevelId" placeholder="请选择代理等级" clearable>
            <el-option v-for="(item,index) in organizations" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4">
          <el-input v-model="searchForm.name" clearable placeholder="请输入代理姓名/手机" auto-complete="off"></el-input>
        </el-col>
        <el-col :sm="12" :md="4" :lg="16" style="text-align:right">
          <el-button type="primary" @click="page.pageNumber=1,pageList()" icon="el-icon-search"
                     v-auth="'/agentUserInfo/pageList'">查询</el-button>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4" style="float:right">
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24" style="margin-bottom: 20px;">
        <el-col style="text-align: left;display:flex" :span="12">
          <el-button type="primary" style="float:left;margin-left:0px;" @click="addFormVisible = true" icon="el-icon-plus"
                     v-auth="'/agentUserInfo/addAgentUserInfo'"
          >添加代理人</el-button>
          <div style="margin-left:20px;color:#888;width:100%;line-height:40px;font-size: 12px;" :key="page.total">代理人员：{{page.total}}</div>
        </el-col>
        <el-col style="text-align: right" :span="12"></el-col>
      </el-row>
      <el-table ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 0px; width: 100%;" border v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)">
        <el-table-column prop="enabled" label="状态" width="100" align="center" :render-header="renderSpecNameHeader">
          <template slot-scope="row">
            <el-switch v-model="row.row.enabled" active-value="1" inactive-value="-1" @change="updateSwitching(row)" class="switchStyle2" active-text="开" inactive-text="关"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="代理人">
          <template slot-scope="row">
            <div class="mainColor" @click="drawerDetailClick(row.row, 'first')" :key="row.row.id">{{row.row.name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="dealCount" label="成交单量"></el-table-column>
        <el-table-column prop="dealAmount" label="成交总额（元）"></el-table-column>
        <el-table-column prop="account" label="联系电话"></el-table-column>
        <el-table-column prop="amount" label="余额(元)">
          <template slot-scope="scope">
            <el-button type="text" @click="drawerDetailClick(scope.row, 'second')">{{scope.row.amount}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <el-button type="text" @click="drawerDetailClick(scope.row, 'first')"
                         v-auth="'/agentUserInfo/drawerDetailClick'"
              >编辑</el-button>
              <!-- <el-button type="text" v-if="scope.row.enabled!=1" style="color:rgb(162, 170, 188)">重置密码</el-button> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, jumper,  total, sizes" style="margin-top: 20px;text-align: right;" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
    </el-card>

    <el-dialog title="添加代理人" :visible.sync="addFormVisible" width="500px" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="所属机构">
              <span style="color: #333333;font-weight: bolder;">{{reqData.agentName}}</span>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="机构ID">
              <span style="color: #333333;font-weight: bolder;">{{reqData.agentId}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="所属校区" prop="campusId">
              <el-cascader style="width:100%;" clearable v-model="addForm.campusId" :show-all-levels="false" :props="CampusProps" placeholder="请选择所属校区" :options="campusList"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="代理姓名" prop="name">
              <el-input style="100%" v-model="addForm.name" placeholder="请输入代理姓名" auto-complete="off" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="联系电话" prop="account">
              <el-input style="100%" v-model="addForm.account" placeholder="请输入联系电话" auto-complete="new-account" maxlength="50"></el-input>
              <div>联系电话即为代理电话，初始密码默认手机号</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="是否启用" prop="enabled">
              <el-radio v-model="addForm.enabled" label="1">启用</el-radio>
              <el-radio v-model="addForm.enabled" label="0">禁用</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAgentUserInfo">确 定</el-button>
      </div>
    </el-dialog>
    
    <drawer-detail
      v-if="drawerDetailShow"
      ref="drawerDetailRef"
      @drawerClose="drawerClose"
    ></drawer-detail>
  </div>
</template>

<script>
import drawerDetail from "./components/drawerDetail.vue";
import { mapGetters } from "vuex";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import SelectHeader from "./SelectHeader";
import { uploadOSS } from "../../upload/upload";

export default {
  components: { ElImageViewer, drawerDetail },
  data () {
    return {
      showViewer: false,
      drawerDetailShow: false,
      amountStats: {},
      rechargeForm: {
        amount: null,
        attachmentList: [],
        objectType: 2,
        objectId: '',
        type: "充值"
      },
      editUserInfoVisible: false,
      editUserInfoForm: {},
      defaultImg: "../../../static/image/defaultImg2.png",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      rechargeLoading: false,
      rowsLoading: false,
      rechargeData: {},
      rechargeFormRules: {
        amount: {
          required: true,
          message: "请选择充值金额",
          trigger: "change"
        },
        attachmentList: {
          required: true,
          message: "请选择支付凭证",
          trigger: "change"
        }
      },
      activeName: "first",
      amount: "",
      srcList: [],
      urlList: [],
      page: {
        rows: [
          {
            agentInfo: { agentLevel: { color: "" } }
          }
        ],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      userInfoPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1
      },
      CampusProps: {
        value: "id",
        children: "children",
        label: "name"
      },
      campusList: [],
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        name: "",
        enabled: "",
        agentLevelId: null
      },
      addForm: {
        account: "",
        agentLevelId: "",
        name: "",
        amount: "",
        enabled: "1"
      },
      addFormRules: {
        campusId: {
          required: true,
          message: "请选择所述校区",
          trigger: "change"
        },
        account: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          },
          {
            min: 1,
            max: 11,
            message: "联系电话长度在1到11个字"
          },
          {
            pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
            message: "联系电话格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入代理姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "姓名长度在1到50个字"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "密码长度在1到50个字"
          }
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "blur"
        }
      },
      editForm: {
        agentLevelId: "",
        account: "",
        name: "",
        amount: "",
        enabled: ""
      },
      editFormRules: {
        campusId: {
          required: true,
          message: "请选择所述校区",
          trigger: "change"
        },
        account: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          },
          {
            min: 1,
            max: 11,
            message: "联系电话长度在1到11个字"
          },
          {
            pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
            message: "联系电话格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入代理姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "姓名长度在1到50个字"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "密码长度在1到50个字"
          }
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "blur"
        }
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      options: [
        { id: "", name: "全部" },
        { id: 1, name: "启用" },
        { id: 0, name: "禁用" }
      ],

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/agentUserInfo/upload`,
      fileList: [],
      loading: true,
      loading: false,
      organizations: []
    };
  },
  methods: {
    // 金额充值
    drawerDetailClick(row, activeName) {
      this.drawerDetailShow = true;
      this.$nextTick(() => {
        this.$refs.drawerDetailRef.init(row, activeName, this.campusList, this.organizations);
      });
    },

    // 关闭抽屉
    drawerClose(val) {
      this.drawerDetailShow = false;
      if(val) {
        this.pageList();
      }
    },

    onPreview (row) {
      this.urlList = [];
      row.row.attachmentList.forEach((e) => {
        this.urlList.push(e.url);
      });
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer () {
      this.showViewer = false;
    },
    editUserInfo (id) {
      this.editUserInfoVisible = true;
      this.api.agentUserInfo
        .getAgentUserInfo({
          id: id
        })
        .then(result => {
          this.editUserInfoForm = result.data;
          this.editUserInfoForm.enabled = String(this.editUserInfoForm.enabled);
        })
        .catch(error => {
          console.log(error);
        });
    },

    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },

    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    updateSwitching (row) {
      if (row.row.enabled == true) {
        row.row.enabled = 1;
      } else {
        row.row.enabled = -1;
      }
      let obj = {
        id: row.row.id,
        enabled: row.row.enabled
      };
      this.api.agentUserInfo.enabledUser(obj).then(result => {
        if (result.success) {
          this.$message.success(result.message);
          this.pageList();
        } else {
          this.$message.error(result.message);
        }
      });
    },
    renderSpecNameHeader (createElement, { column, $index }) {
      let self = this;

      //该列的绑定数据
      // console.log(column);
      //列号
      // console.log($index);

      return createElement(
        "div",
        {
          style: "display:flex;padding:0px;margin-left:30px"
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label
            }
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "specId",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName"
              }
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            }
          })
        ]
      );
    },
    //选择框回调
    selectChange (val) {
      this.page.pageNumber = 1;
      this.searchForm.enabled = val;
      this.pageList();
    },
    pageList () {
      this.loading = true;
      this.searchForm.account = this.searchForm.name;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.searchForm.isAgentUser = 1;
      this.api.agentUserInfo
        .pageList(this.searchForm)
        .then(result => {
          this.loading = false;
          if (result.success) {
            for (let i in result.data.records) {
              result.data.records[i].enabled = result.data.records[i].enabled.toString();
            }
            this.page.rows = result.data.records;
            this.page.total = result.data.total;
          } else {
            this.$message.error(result.message);
          }
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addAgentUserInfo () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (typeof this.addForm.campusId == "object") {
            let index = this.addForm.campusId.length;
            this.addForm.campusId = this.addForm.campusId[index - 1];
          }
          this.addForm.agentId = this.loginData.agentId;
          this.api.agentUserInfo
            .addAgentUserInfo(this.addForm)
            .then(result => {
              if (result.success) {
                this.addFormVisible = false;
                this.pageList();
                this.$message.success(result.message);
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteAgentUserInfo (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentUserInfo
            .deleteAgentUserInfo([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    resetPassword (row) {
      this.$confirm("您确定要重置密码吗？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.api.agentUserInfo.resetPassword({ id: row }).then(result => {
          if (result.success) {
            this.$message.success("操作成功，密码为您的手机号！");
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    getAgentAmountStatsDTO () {
      this.api.agentUserInfo.getAgentAmountStatsDTO().then(result => {
        this.amount = result.data.amount;
      });
    },
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    batchDeleteAgentUserInfo () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentUserInfo
            .deleteAgentUserInfo(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    getAgentInfoList () {
      this.api.agentLevel.getAgentLevelList().then(result => {
        this.organizations = result.data;
      });
    }

  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.loginData;
    },
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
      }
    }
  },
  filters: {
    NumFormat: function (value) {
      if (!value) return "0";
      var intPart = Number(value) | 0; // 获取整数部分
      var intPartFormat = intPart
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
      var floatPart = ""; //预定义小数部分
      var valueSplit = String(value);
      var value2Array = valueSplit.split(".");
      //=2表示数据有小数位
      if (value2Array.length == 2) {
        floatPart = value2Array[1].toString(); //拿到小数部分

        if (floatPart.length == 1) {
          //补0,实际上用不着
          return intPartFormat + "." + floatPart;
        } else {
          return intPartFormat + "." + floatPart;
        }
      } else {
        return intPartFormat + floatPart;
      }
    }
  },
  mounted () {
    this.pageList();
    this.getAgentInfoList();
    this.getAgentAmountStatsDTO();
    this.getCampusList();
  }
};
</script>
<style lang="less">
::v-deep .agentUserInfo_upload{
  ::v-deep .el-upload-list{
    display: block!important;
  }
}
</style>
<style lang="less" scoped>
/deep/ .el-switch__label--right {
  left: -16px !important;
}
.rowName {
  width: 80px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background-color: rgba(199, 113, 246, 1);
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #fff;
  overflow: hidden;
}
.img {
  .el-icon-circle-close {
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agentUserInfo/agentUserInfo.vue